$(function() {

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $('#sendContactMember').on('click', function() {
        var btnSend = $(this),
            form = $('#contactModal form');

        $.ajax({
            url: form.attr('action'),
            data: form.serialize(),
            type: 'POST',
            beforeSend: function( xhr ) {
                btnSend.addClass('disabled');
                $('#contactModal .modal-body .alert').remove(); // remove all alert boxes
            }
        })
        .done(function( data, textStatus, jqXHR ) {
            $('#contactModal .modal-body').prepend('<div class="alert alert-success" role="alert"> \
                '+data.message+' \
            </div>');

            setTimeout(function() {
                $('#contactModal').modal('hide'); // close modal
                form.find("input[type=text]:not([readonly]), textarea").val(""); // empty form fields
                $('#contactModal .modal-body .alert').remove(); // remove all alert boxes
            }, 3000);
        })
        .fail(function( jqXHR, textStatus, errorThrown ) {
            if(jqXHR.status == 422) {
                var errors = _.map(jqXHR.responseJSON, function (error, field) {
                    return '<li>' + error + '</li>';
                });

                $('#contactModal .modal-body').prepend('<div class="alert alert-danger" role="alert"> \
                    <ul>\
                        '+errors.join('')+'\
                    </ul>\
                </div>');
            } else {
                $('#contactModal .modal-body').prepend('<div class="alert alert-danger" role="alert"> \
                    <p>SERVER ERROR</p> \
                    '+errorThrown+'\
                </div>');
            }

        })
        .always(function() {
            btnSend.removeClass('disabled');
        });
    });

});
